import { Route } from '@angular/router';
import { NetworkShareEditComponent } from 'src/app/pages/network/network-share-edit/network-share-edit.component';
import { NetworkShareComponent } from 'src/app/pages/network/network-share/network-share.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const share: Route = {
  path: 'networkShare',
  title: 'nav.network.share',
  data: {
    breadcrumb: 'nav.network.share',
    icon: SbIcons.networkShare,
    id: RoutingID.networkShare,
  },
  children: [
    {
      path: '',
      component: NetworkShareComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'networkShare-edit/:networkshareID',
      title: 'nav.network.share.editShare',
      data: {
        breadcrumb: 'nav.network.share.editShare',
        icon: SbIcons.edit,
        id: RoutingID.networkShareEdit,
      },
      children: [
        {
          path: '',
          component: NetworkShareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'networkShare-create',
      title: 'nav.network.share.createShare',
      data: {
        breadcrumb: 'nav.network.share.createShare',
        icon: SbIcons.plus,
        id: RoutingID.networkShareCreate,
      },
      children: [
        {
          path: '',
          component: NetworkShareEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
